import { app } from './index';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3030';

const getAccessToken = async () => {
  try {
    if (app?.authentication?.getAccessToken) {
      const token = await app.authentication.getAccessToken();
      if (token) return token;
    }
  } catch (error) {
    // fallback below
  }

  const auth = app?.get?.('authentication');
  if (auth?.accessToken) return auth.accessToken;

  const localToken = window.localStorage.getItem('feathers-jwt');
  return localToken || null;
};

export const uploadDocumentFile = async ({ file, id_institucion, id_owner, id_cliente, vc_nombre_original }) => {
  if (!file) {
    throw new Error('Archivo requerido para cargar documento.');
  }

  const token = await getAccessToken();
  if (!token) {
    throw new Error('Sesión no autenticada para cargar documento.');
  }

  const formData = new FormData();
  formData.append('file', file);
  if (id_institucion) formData.append('id_institucion', id_institucion);
  if (id_owner) formData.append('id_owner', id_owner);
  if (id_cliente) formData.append('id_cliente', id_cliente);
  if (vc_nombre_original) formData.append('vc_nombre_original', vc_nombre_original);

  const response = await fetch(`${baseURL}/documents/upload`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const errorMessage = payload?.message || `Error al cargar documento (HTTP ${response.status})`;
    throw new Error(errorMessage);
  }

  return payload;
};

export const getDocumentDownloadUrl = (documentId) => `${baseURL}/documents/${documentId}/download`;

